import request from "@/utils/request";

// 会员价格查询
export function memberPriQueryApi(params) {
    return request({
      url: `/memberMoney/selectZcMemberMoney`,
      method: "POST",
      headers: { "Content-Type": "application/json;charset=UTF-8" },
      params
    });
}

// 积分价格查询
export function pointsPriQueryApi(params) {
    return request({
      url: `/pointsPrice/selectZcPointsPrice`,
      method: "POST",
      headers: { "Content-Type": "application/json;charset=UTF-8" },
      params
    });
}

// 会员充值 生成微信二维码
export function wxQrcodeApi(params) {
    return request({
      url: `/pay/wxMemberQrCode`,
      method: "POST",
      headers: { "Content-Type": "application/json;charset=UTF-8" },
      params
    });
}

// 查询会员微信订单支付状态
export function queryWxPayStatus(params) {
    return request({
      url: `/pay/queryMemberWxPayStatus`,
      method: "POST",
      headers: { "Content-Type": "application/json;charset=UTF-8" },
      params
    });
}

// 会员充值 生成支付宝二维码
export function zfbQrcodeApi(params) {
    return request({
      url: `/pay/zfbMemberQrCode`,
      method: "POST",
      headers: { "Content-Type": "application/json;charset=UTF-8" },
      params
    });
}

// 查询会员支付宝订单支付状态
export function queryZfbPayStatus(params) {
    return request({
      url: `/pay/queryMemberZfbPayStatus`,
      method: "POST",
      headers: { "Content-Type": "application/json;charset=UTF-8" },
      params
    });
}

// 积分充值 生成微信二维码
export function wxPointsQrcodeApi(params) {
  return request({
    url: `/pay/wxPointsQrCode`,
    method: "POST",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    params
  });
}

// 查询积分充值 微信订单支付状态
export function queryPointsWxPayStatus(params) {
  return request({
    url: `/pay/queryWxPayPointsStatus`,
    method: "POST",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    params
  });
}

// 积分充值 生成支付宝二维码
export function zfbPointsQrcodeApi(params) {
  return request({
    url: `/pay/zfbPointsQrCode`,
    method: "POST",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    params
  });
}

// 查询积分充值 支付宝订单支付状态
export function queryZfbPointsPayStatus(params) {
  return request({
    url: `/pay/queryZfbPayPointsStatus`,
    method: "POST",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    params
  });
}